require('./accountCancelChequesSuccessStep.scss');

const PropTypes = require('prop-types');

//@vendors
const React = require('react');

//@helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');

const AccountCancelChequesSuccessStep = props => {
    const {chequeNumber, backUrl} = props;
    const title = formatText('accountCancelCheques-successStepInfoText', [chequeNumber]);
    const goBackButtonLabel = <FormattedText value="accountCancelCheques-successStepBackLink" format="uppercase"/>;
    const mainButton = {
        label: goBackButtonLabel,
        url: backUrl
    };


    return (
        <WizardSuccess
            successMessage={title}
            mainButton={mainButton}
        />
    );
};

AccountCancelChequesSuccessStep.propTypes = {
    backUrl: PropTypes.string.isRequired,
    chequeNumber: PropTypes.string.isRequired
};

module.exports = AccountCancelChequesSuccessStep;